<template>
    <div class="requests-page-container">
        <v-btn color="primary" v-if="hasPermission('CREATE_PHONE_BOOKING')" @click="create_phone_booking = true">
            Create Phone Booking
        </v-btn>
        <v-btn :loading="loadingUpdateLocations" fixed bottom large right color="error" v-if="!!activeBookingId"
               style="z-index: 1000;"
               @click="passwordDialog = true">
            Update Locations
        </v-btn>
        <loading-component :value="loading"/>
        <v-dialog :value="!!activeBookingId" @input="closeMap" lazy width="50%">
            <Map v-if="!!activeBookingId" only-markers height="90vh" :appendMarkers="markers"/>
        </v-dialog>
        <v-dialog :value="passwordDialog" @input="passwordDialog = null, password = null" lazy width="50%">
            <v-card>
                <v-text-field :disabled="loading" type="password" label="Enter your password verify action"
                              v-model="password" full-width/>
                <v-checkbox label="Detach voucher if needed" v-model="detach_voucher"></v-checkbox>
                <v-btn color="primary" @click="updateLocations">
                    Update Locations
                </v-btn>
            </v-card>
        </v-dialog>
        <v-layout row v-if="!loading">
            <v-flex xs12 :md10="nowBookings.length > 0">
                <v-container :class="{'max-scroll-full-height': nowBookings.length > 0}">
                    <v-layout row wrap class="indicators-and-actions">
                        <v-flex xs12 id="clearSelectedButton" :class="{show:numberOfSelected > 0}">
                            <v-btn flat color="primary" @click="selectedBookings = []">
                                Clear Selected
                            </v-btn>
                        </v-flex>
                        <v-flex md3 sm6 xs12>
                            <v-icon color="#F006">fa fa-square</v-icon>
                            Late More than 30 minutes
                        </v-flex>
                        <v-flex md3 sm6 xs12>
                            <v-icon color="#FF06">fa fa-square</v-icon>
                            Late Less 30 minutes
                        </v-flex>
                        <v-flex md3 sm6 xs12>
                            <v-icon color="#0F06">fa fa-square</v-icon>
                            Within 30 minutes
                        </v-flex>
                        <v-flex md3 sm6 xs12>
                            <v-icon color="#0FF6">fa fa-square</v-icon>
                            After 30 minutes or more
                        </v-flex>
                        <v-flex xs12>
                            <v-menu ref="menu" :close-on-content-click="false" :nudge-right="40" lazy
                                    transition="scale-transition" offset-y full-width min-width="290px">
                                <v-text-field slot="activator" v-model="date" label="Show Requests Of Date:"
                                              prepend-icon="event" readonly/>
                                <v-date-picker ref="picker" v-model="date"
                                               :min="(moment().subtract(2,'day').format('YYYY-MM-DD'))"/>
                            </v-menu>
                        </v-flex>
                    </v-layout>

                    <transition-group v-for="chunk of chunkedSlices" tag='div'
                                      class='layout row wrap justify-space-between' name="slide-fade">
                        <v-flex md3 sm12 v-for="slice of chunk" :key="'slice-'+slice" style="margin-bottom: 8px">
                            <v-card>
                                <v-card-title primary-title>
                                    <div style="width:100%">
                                        <h3 class="h3 mb-0">{{slice}}</h3>
                                        <transition-group name='fade' tag="div" class="list-scrollable">
                                            <template v-for="(bookingId,idx) of sortedSlices[slice]">
                                                <request-card :item="bookings[bookingId]"
                                                              :hide-actions="makingAction"
                                                              :key="'request-' + bookingId"
                                                              :style="itemGradientStyle[bookingId]"
                                                              :selected="selectedBookings.indexOf(bookingId) !== -1"
                                                              @select="selectBooking"
                                                              @unselect="unselectBooking"
                                                              change-service
                                                              @approve="generateRideFromBooking(bookingId)"
                                                              @reject="openConfirmDialog(bookingId, 'Reject')"
                                                              @delete="openConfirmDialog(bookingId, 'Delete')"
                                                              @dispatchSuggest="openCreateDispatchSuggestDialog(bookingId)"
                                                              @dispatchSuggestions="openDispatchSuggestionHistoryDialog(bookingId)"
                                                              @map="activeBookingId = bookingId"/>
                                                <v-divider :key="'divider-request-' + idx"
                                                           v-if="idx !== sortedSlices[slice].length-1"></v-divider>
                                            </template>
                                            <infinite-loading :key="'infinite-loading-'+slice"
                                                              v-if="finishedSlices.indexOf(slice) === -1"
                                                              @infinite="state => getMore(slice,state)">
                                                <div slot="no-more">No more bookings</div>
                                                <div slot="no-results">No more bookings</div>
                                            </infinite-loading>
                                        </transition-group>
                                    </div>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                    </transition-group>
                    <v-layout v-if="!rideAction"
                              :class="{'fab-container': true,'active': numberOfSelected > 0,'pa-3': true}"
                              style="z-index: 10">
                        <v-btn color="pink" dark round large
                               @click="numberOfSelected > 0 ? rideAction = 'join' : null">
                            <v-icon class="pa-1" small>fa fa-car</v-icon>
                            Join Ride
                        </v-btn>
                        <v-btn color="green" dark round large
                               @click="numberOfSelected > 0 ? rideAction = 'generate': null">
                            <v-icon>add</v-icon>
                            Generate Ride
                        </v-btn>
                    </v-layout>

                    <v-dialog :value="rideAction === 'generate'" @input="rideAction = null"
                              :key="'generate-'+rideActionKey" lazy
                              max-width="50%"
                              style="position: relative;">
                        <generate-ride :selected-items="selectedBookings.map(id => bookings[id])"
                                       @close="rideAction = null"/>
                    </v-dialog>
                    <v-dialog :value="rideAction === 'join'" @input="rideAction = null" :key="'join-'+rideActionKey"
                              lazy
                              max-width="50%"
                              style="position: relative;">
                        <join-ride :selected-items="selectedBookings.map(id=>bookings[id])" @close="rideAction = null"/>
                    </v-dialog>
                </v-container>
            </v-flex>
            <v-flex v-if="nowBookings.length > 0" xs12 md2 style="position: relative;">
                <div class="now-requests-container">
                    <div class="now-requests-list">
                        <div class="title text-sm-center pa-2 ">Now Bookings</div>
                        <transition-group name='fade' tag="div" class="list" v-if="nowBookings.length">
                            <request-card v-for="bookingId of nowBookings" :key="'now-booking-' + bookingId"
                                          :hide-actions="makingAction"
                                          :item="bookings[bookingId]"
                                          :selected="selectedBookings.indexOf(bookingId) !== -1"
                                          @select="selectBooking"
                                          @approve="generateRideFromBooking(bookingId)"
                                          @unselect="unselectBooking"
                                          @reject="openConfirmDialog(bookingId)"
                                          @map="activeBookingId = bookingId"/>
                            <infinite-loading
                                    :identifier="finishedSlices.indexOf('now') !== -1 ? 1 : nowBookings.length"
                                    key="infinite-loading-now"
                                    @infinite="state => getMore('now',state)">
                                <div slot="no-more">No more bookings</div>
                                <div slot="no-results">No more bookings</div>
                            </infinite-loading>
                        </transition-group>
                    </div>
                </div>
            </v-flex>
        </v-layout>
        <v-dialog v-model="confirm_dialog" width="500">
            <v-card>
                <v-card-title class="headline red lighten-2" primary-title>
                    Warning
                </v-card-title>
                <v-card-text>
                    Are you sure you want to {{confirm_dialog_message}} this booking?
                    <v-text-field v-model="password" v-if="confirm_dialog_message === 'Delete'" required
                                  append-icon="lock" label="Enter your password" type="password"></v-text-field>
                    <v-flex xs12
                            v-if="confirm_dialog_message === 'Reject' && ai_suggested_bookings.indexOf(parseInt(selected_reject_booking_id)) !== -1">
                        <v-radio-group v-model="reason" column color="blue">
                            <v-radio
                                    v-for="item in $store.state.user.settings.REJECT_AGAINST_AI_OPTIONS"
                                    :label="item"
                                    :value="item"
                                    :key="item"
                            />
                            <v-radio label="Other"
                                     value="other"
                            />
                        </v-radio-group>
                        <v-text-field v-if="reason === 'other'" label="Other" v-model="other"/>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="rejectBooking(selected_reject_booking_id)">
                        I accept
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dispatch_suggestions_history_dialog">
            <v-card>
                <v-card-title class="headline lighten-2" primary-title>
                    Suggestion History
                </v-card-title>
                <v-card-text>
                    <v-flex xs12>
                        <DataTable
                                :key="dispatch_suggestions_history_dialog.toString() + dispatch_suggestions_history_endpoint"
                                :url="dispatch_suggestions_history_endpoint" :enable-edit="false" :enable-add="false"
                                :enable-delete="false" :disable-search="true"/>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
            </v-card>
        </v-dialog>

        <v-dialog v-model="create_dispatch_suggestion_dialog" width="500">
            <v-card>
                <v-card-title class="headline lighten-2" primary-title>
                    Suggest Dispatch To
                </v-card-title>
                <v-card-text>
                    <v-flex xs12>
                        <choose-captains-multi :multi="false"
                                               v-model="suggested_captain_id_to_dispatch"
                                               :initial-search-params="suggestCaptainSearchParams"></choose-captains-multi>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="suggestDispatch">
                        Suggest
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <booking-suggestion-dialog :visible="booking_suggestion.visible" @switch="booking_suggestion.visible = false"
                                   :data="booking_suggestion.data"></booking-suggestion-dialog>
        <going-offline-dialog :visible="going_offline.visible" @switch="going_offline.visible = false"
                              :data="going_offline.data"></going-offline-dialog>
        <v-dialog v-model="create_phone_booking">
            <create-phone-booking :key="create_phone_booking" @create="create_phone_booking = false"/>
        </v-dialog>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import _ from "lodash";
    import InfiniteLoading from 'vue-infinite-loading';
    import Map from "@/views/monitoring/Map";
    import Mapbox from "mapbox-gl";
    import ChooseCaptainsMulti from "@/components/wasilni/input/ChooseCaptainMulti";
    import RequestCard from "@/components/wasilni/RequestCard";
    import GenerateRide from "@/components/GenerateRide";
    import JoinRide from "@/components/JoinRide";
    import NewRequestDing from "@/assets/new_now_request_ding.mp3";
    import moment from "moment";
    import socketEventsMixin from "@/mixins/socketEventsMixin";
    import hasIntervalsMixin from "@/mixins/hasIntervalsMixin";
    import DataTable from "@/components/wasilni/DataTable";
    import BookingSuggestionDialog from "@/components/wasilni/BookingSuggestionDialog";
    import GoingOfflineDialog from "@/components/wasilni/GoingOfflineDialog";
    import CreatePhoneBooking from "@/components/requests/CreatePhoneBooking";

    export default {
        mixins: [socketEventsMixin, hasIntervalsMixin],
        name: "Requests",
        title: "Requests",
        components: {
            BookingSuggestionDialog,
            DataTable,
            JoinRide, GenerateRide, RequestCard, ChooseCaptainsMulti, Map, LoadingComponent, InfiniteLoading,
            GoingOfflineDialog,
            CreatePhoneBooking
        },
        data() {
            return {
                booking_suggestion: {
                    visible: false,
                    data: {}
                },
                going_offline: {
                    visible: false,
                    data: {}
                },
                create_phone_booking: false,
                suggestCaptainSearchParams: new URLSearchParams(),
                create_dispatch_suggestion_dialog: false,
                booking_id_to_suggest_dispatch: null,
                suggested_captain_id_to_dispatch: null,
                dispatch_suggestions_history_dialog: false,
                dispatch_suggestions_history_endpoint: "",
                ai_suggested_bookings: [],
                confirm_dialog_message: '',
                selected_reject_booking_id: null,
                confirm_dialog: false,
                finishedSlices: [],
                makingAction: false,
                rideActionKey: 0,
                drawer: false,
                selectedBookings: [], // id1,id2,id3
                serviceSelected: null,
                loading: false,
                busy: false,
                bookings: {},
                loadingUpdateLocations: false,
                maxIdElement: 1,
                date: "",
                activeBookingId: null,
                itemGradientStyle: {},
                passwordDialog: null,
                password: null,
                detach_voucher: false,
                rideAction: null, // generate || join
                reason: "other",
                other: null

            }
        },
        watch: {
            rideAction(val) {
                if (!val)
                    this.rideActionKey++;
            },
            selectedBookings(selectedBookings) {
                if (selectedBookings.length === 0)
                    this.serviceSelected = null;
            },
            bookings(bookings) {
                this.selectedBookings = this.selectedBookings.filter(key => !!bookings[key]);
                this.computeGradients();
            },
            date(val) {
                this.loading = true;
                this.finishedSlices = [];
                this.selectedBookings = [];
                this.bookings = {};
                const params = new URLSearchParams();
                params.append('status', 'PENDING');
                params.append('sliced', 'true');
                params.append('date', val);
                this.axios.get(this.api.ACTIONS.BOOKINGS, {params}).then(
                    ({data}) => {
                        this.loading = false;
                        this.addBookings(data.data, true);
                    }
                );
            }
        },
        mounted() {
            this.date = moment().format("YYYY-MM-DD");
        },
        computed: {
            nowBookings() {
                const nowBookings = [];
                for (let id of Object.keys(this.bookings)) {
                    const booking = this.bookings[id];
                    if (!!booking.now)
                        nowBookings.push(id);
                }
                return nowBookings;
            },
            slices() { // slice => [bookingId1,bookingId2,bookingId3,bookingId4....bookingIdN]
                const slices = {};
                for (let id of Object.keys(this.bookings)) {
                    const booking = this.bookings[id];
                    const {slice, now} = booking;
                    if (!slice || !!now) continue;
                    slices[slice] ? slices[slice].push(id) : slices[slice] = [id];
                }
                return slices;
            },
            markers() {
                const activeBooking = this.bookings[this.activeBookingId];
                if (!activeBooking) return [];
                const markers = [new Mapbox.Marker({
                    color: "#00ff0f",
                    symbol: 'S',
                    draggable: true
                }), new Mapbox.Marker({color: "#ff000f", symbol: 'E', draggable: true})];
                markers[0].setLngLat(activeBooking.pick_up_location.coordinates);
                markers[1].setLngLat(activeBooking.pull_down_location.coordinates);
                return markers;
            },
            chunkedSlices() {
                return _.chunk(Object.keys(this.sortedSlices).sort(), 4);
            },
            sortedSlices() {
                const slices = Object.assign({}, this.slices);
                const bookings = this.bookings;
                for (let slice in slices)
                    slices[slice] = slices[slice].sort((a, b) => bookings[a].datetime < bookings[b].datetime ? -1 : 1);
                return slices;
            },
            numberOfSelected() {
                return this.selectedBookings.length;
            }
        },
        methods: {
            suggestDispatch() {
                if (!this.booking_id_to_suggest_dispatch) {
                    window.getApp.$emit("SHOW_TOAST", 'invalid info', "red");
                    return;
                }
                this.axios.post(`booking/${this.booking_id_to_suggest_dispatch}/suggest_captain`, {captain_id: this.suggested_captain_id_to_dispatch})
                    .then(() => {
                        window.getApp.$emit("SHOW_TOAST", 'Done', "green");
                        this.create_dispatch_suggestion_dialog = false;
                    })
                    .catch(err => {
                        try {
                            if (err.response.data.message) {
                                window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
                            } else {
                                window.getApp.$emit("SHOW_TOAST", err.message, "red");
                            }
                        } catch (e) {
                            console.log(err.message, e.message);
                        }
                    })
            },
            openCreateDispatchSuggestDialog(booking_id) {
                const params = new URLSearchParams();
                params.append('service', this.bookings[booking_id].service_id);
                params.append('state', 'approved');
                this.suggestCaptainSearchParams = params;
                this.booking_id_to_suggest_dispatch = booking_id;
                this.create_dispatch_suggestion_dialog = true;
            },
            openDispatchSuggestionHistoryDialog(booking_id) {
                this.dispatch_suggestions_history_endpoint = `booking/${booking_id}/captain_suggestions`;
                this.dispatch_suggestions_history_dialog = true;
            },
            closeMap() {
                const oldPickUpLocation = JSON.stringify(this.bookings[this.activeBookingId].pick_up_location.coordinates);
                const oldPullDownLocation = JSON.stringify(this.bookings[this.activeBookingId].pull_down_location.coordinates);
                const newPickUpLocation = JSON.stringify(this.markers[0].getLngLat().toArray());
                const newPullDownLocation = JSON.stringify(this.markers[1].getLngLat().toArray());
                if (oldPickUpLocation !== newPickUpLocation || oldPullDownLocation !== newPullDownLocation)
                    confirm("Are you sure you want to exit (your changes aren't saved yet) ") ?
                        this.activeBookingId = null : "";
                else
                    this.activeBookingId = null;
            },
            updateLocations() {
                this.loadingUpdateLocations = true;
                const {password} = JSON.parse(JSON.stringify(this.$data));
                this.password = null;
                this.passwordDialog = null;
                this.axios.put(this.api.ACTIONS.BOOKINGS + '/' + this.activeBookingId, {
                    detach_voucher: this.detach_voucher,
                    pick_up_location: {
                        type: "Point",
                        coordinates: this.markers[0].getLngLat().toArray()
                    },
                    pull_down_location: {
                        type: "Point",
                        coordinates: this.markers[1].getLngLat().toArray()
                    },
                    password
                }).then(
                    ({data: {data: booking}}) => {
                        this.bookings = Object.assign(
                            {},
                            this.bookings,
                            {
                                [this.activeBookingId]: Object.assign(
                                    {}, this.bookings[this.activeBookingId], booking
                                )
                            }
                        );
                        window.getApp.$emit("SHOW_TOAST", "Updated Locations !")
                    }
                ).catch(
                    () =>
                        window.getApp.$emit("SHOW_TOAST", "Check your password", "red")
                ).finally(
                    () => {
                        this.loadingUpdateLocations = false;
                        this.detach_voucher = false;
                    }
                );
            },
            generateRideFromBooking(bookingId) {
                this.selectedBookings = [];
                this.selectBooking(this.bookings[bookingId.toString()]);
                this.rideAction = 'generate'
            },
            addBookings(bookings, setFinishedToSlices = false) {
                if (!(bookings instanceof Array))
                    bookings = [bookings];
                if (bookings.length === 0) return;
                this.bookings = Object.assign(
                    ...bookings.map(item => ({[item.id.toString()]: item})),
                    this.bookings
                );
                if (setFinishedToSlices) {
                    for (let slice in this.slices)
                        if (this.slices[slice].length < 2)
                            this.finishedSlices.push(slice);
                }
            },
            openConfirmDialog(booking_id, message) {
                this.selected_reject_booking_id = booking_id;
                this.confirm_dialog_message = message;
                this.confirm_dialog = true;
            },
            rejectBooking(bookingId) {
                if (!this.password && this.confirm_dialog_message === 'Delete') {
                    window.getApp.$emit("SHOW_TOAST", 'Enter your password to verify this operation', "red");
                    return;
                }

                const key = this.reason === 'other' ? 'other' : 'reason';
                this.axios.delete(this.api.ACTIONS.BOOKINGS + '/' + bookingId + (this.confirm_dialog_message === 'Delete' ? '?delete' : ''), {
                    data: {
                        password: this.password,
                        [key]: this[key]
                    }
                }).then(() => {
                    window.getApp.$emit("SHOW_TOAST", "REJECTED");
                    this.bookings = _.pickBy(this.bookings, (value, key) => key !== bookingId);
                    this.selected_reject_booking_id = null;
                    this.confirm_dialog = false;
                    this.confirm_dialog_message = null;
                    this.makingAction = true;
                }).catch((err) => {
                    try {
                        if (err.response.data.message) {
                            window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
                        } else {
                            window.getApp.$emit("SHOW_TOAST", err.message, "red");
                        }
                    } catch (e) {
                        console.log(err.message, e.message);
                    }
                }).finally(() => this.makingAction = false);
            },
            computeGradients() {
                const data = {};
                for (let slice in this.slices)
                    for (let bookingId of this.slices[slice])
                        data[bookingId] = this.getItemGradientStyle(this.bookings[bookingId]);
                this.itemGradientStyle = data;
            },
            getItemGradientStyle(item) {
                const bookingTime = moment(item.datetime);
                const now = moment();
                const opacity = 0.1;
                if (item.airport_office) {
                    return `background-color: gold;`;
                } else if (bookingTime.diff(now, 'minutes') === 0) {
                    //language=CSS
                    return `background-color: rgba(0,255,0,${opacity});`
                } else if (bookingTime > now) {
                    const diff = bookingTime.diff(now, 'minute');
                    if (diff > 30)//language=CSS
                        return `background-color: rgba(0,255,255,${opacity});`;
                    else //language=CSS
                        return `background-color: rgba(0,255,0,${opacity})`;
                } else if (now > bookingTime) {
                    const diff = now.diff(bookingTime, 'minutes');
                    if (diff > 30)//language=CSS
                        return `background-color: rgba(255,0,0,${opacity});`;
                    else //language=CSS
                        return `background-color: rgba(255,255,0,${opacity})`;
                }
            },
            selectBooking(item) {
                if (this.serviceSelected === null)
                    this.serviceSelected = item.service;
                if (item.service.id === this.serviceSelected.id) {
                    if (this.serviceSelected.is_pooling || this.numberOfSelected === 0)
                        this.selectedBookings = [...this.selectedBookings, item.id.toString()];
                    else
                        window.getApp.$emit("SHOW_TOAST", `Service ${this.serviceSelected.name} is Not Pooling!`, "orange", ['center', 'top']);
                } else
                    window.getApp.$emit("SHOW_TOAST", "Joining Bookings require them to be of same service", 'red', ['center', 'top']);

            },
            unselectBooking(item) {
                this.selectedBookings = _.reject(this.selectedBookings, id => item.id.toString() === id);
                if (this.numberOfSelected === 0)
                    this.serviceSelected = null;
            },
            getMore(slice, state) {
                const finishedSlices = this.finishedSlices;
                if (finishedSlices.indexOf(slice) === -1) {
                    const params = new URLSearchParams();
                    params.append('slice', slice);
                    params.append('status', 'PENDING');
                    params.append('perPage', "50");
                    params.append('date', this.date);
                    if (slice !== 'now')
                        for (let id in this.slices[slice])
                            params.append(`existing_booking_ids[${id}]`, this.slices[slice][id]);
                    else
                        for (let id in this.nowBookings)
                            params.append(`existing_booking_ids[${id}]`, this.nowBookings[id]);
                    this.axios.get(this.api.ACTIONS.BOOKINGS, {
                        params
                    }).then(({data}) => {
                        if (data.data.data.length === 0) {
                            state.complete();
                            finishedSlices.push(slice);
                        } else {
                            this.addBookings(data.data.data);
                            if (!data.data.next_page_url) {
                                finishedSlices.push(slice);
                                state.complete();
                            } else
                                state.loaded();
                        }

                    });
                } else {
                    state.complete();
                }
            },
            socketRemoveBooking(bookingId) {
                this.bookings = _.pickBy(this.bookings, (value, key) => key.toString() !== bookingId.toString());
            },
            goingOffline(data) {
                this.going_offline.visible = true;
                this.going_offline.data = data;
            },
            socketNewBooking(requestStringified) {
                const finishedSlices = this.finishedSlices;
                const booking = JSON.parse(requestStringified);
                const bookingSlice = booking.slice;
                if (moment(booking.datetime).format('YYYY-MM-DD') !== this.date) return;
                if (!bookingSlice || !this.slices[bookingSlice] || this.slices[bookingSlice].length === 0 ||
                    finishedSlices.indexOf(bookingSlice) !== -1 || this.slices[bookingSlice].splice(-1).datetime >= booking.datetime) {
                    if (!this.slices[bookingSlice])
                        this.finishedSlices = [...this.finishedSlices, bookingSlice];
                    this.addBookings(booking);
                    (new Audio(NewRequestDing)).play();
                }
            },
            socketUpdateBooking(bookingStringfied) {
                const booking = JSON.parse(bookingStringfied);
                const bookingID = booking.id.toString();
                this.bookings = Object.assign(
                    {},
                    this.bookings,
                    {
                        [bookingID]: Object.assign(
                            {},
                            this.bookings[bookingID] ? this.bookings[bookingID] : {},
                            booking
                        )
                    }
                );
            },
            ai_timeline(data) {
                this.ai_suggested_bookings = _.flatten(data.workers.map(
                    worker => worker.worker_rides.map(ride => ride.task_id)
                ));
            },
            bookingSuggestionAvailable(data) {
                console.log('EVENT RECEIVED', data);
                this.$set(this.booking_suggestion, 'data', data);
                this.booking_suggestion.visible = true;
            },
        },
        intervals() {
            return [
                [this.computeGradients, 60 * 1000]
            ];
        },
        events() {
            return {
                [this.api.SOCKET.EVENTS.UPDATE_BOOKING]: this.socketUpdateBooking,
                [this.api.SOCKET.EVENTS.DELETE_BOOKING]: this.socketRemoveBooking,
                [this.api.SOCKET.EVENTS.NEW_PENDING_BOOKING]: this.socketNewBooking,
                'Dashboard:booking_suggestion_available': this.bookingSuggestionAvailable,
                'Ai:timeline': this.ai_timeline,
                'Dashboard:going_offline': this.goingOffline
            }
        }
    }
</script>

<style lang="scss">
    .requests-page-container {

        .list-scrollable {
            height: 250px;
            overflow-y: auto;
        }

        .fab-container {
            position: fixed;
            bottom: 0;
            right: 0;
            opacity: 0;
            transition: opacity .5s linear;

            &.active {
                opacity: 1;
            }
        }

        .item-selected-rejected {
            position: absolute;
            right: 0;
            color: white;
            padding: 1px;
            height: 25px;
            width: 25px;
            border-radius: 25px;
            text-align: center;
            align-items: center;
            display: inline-block;
            background: indianred;
        }

        .item-selected-important {
            position: absolute;
            right: 0;
            color: white;
            padding: 1px;
            height: 25px;
            width: 25px;
            border-radius: 25px;
            text-align: center;
            align-items: center;
            display: inline-block;
            background: orangered;
        }

        .now-requests-container {
            position: relative;
            background: #EEE5;

            .now-requests-list {
                position: sticky;

                .list {
                    overflow-y: scroll;
                    height: 100vh;
                }
            }
        }

        #clearSelectedButton {
            opacity: 0;
            transition: opacity 0.5s;

            &.show {
                opacity: 1;
            }
        }

        .fade-enter-active {
            transition: all .3s ease;
        }

        .fade-enter, .fade-leave-to {
            opacity: 0;
        }

        .slide-fade-enter-active {
            transition: all .3s ease;
        }

        .slide-fade-leave-active {
            transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
        }

        .slide-fade-enter, .slide-fade-leave-to {

            transform: translateX(-10px);
            opacity: 0;
        }

        .max-scroll-full-height {
            max-height: 100vh;
            overflow-y: scroll;
        }

    }
</style>